import { render, staticRenderFns } from "./RewardCategoryItem.vue?vue&type=template&id=75ca0e41&scoped=true&"
import script from "./RewardCategoryItem.vue?vue&type=script&lang=js&"
export * from "./RewardCategoryItem.vue?vue&type=script&lang=js&"
import style0 from "./RewardCategoryItem.vue?vue&type=style&index=0&id=75ca0e41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ca0e41",
  null
  
)

export default component.exports